















































import { Component, Vue, } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import * as RouteNames from "@/employee/route-names";
import { FetchState, HsabSsoDestination, hsabExpenseReimbursementMethodMap,
  LinkedBankAccountUse, LinkedBankAccountUseStatus } from "@/shared/types";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import _ from "lodash";

@Component({
  computed: {
    FetchState () {
      return FetchState;
    },
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: { SsoDeepLink, GenericLoadingSpinner }
})
export default class HsabExpensePaymentDetails extends Vue {
  contactInformationStore = useContactInfoStore();
  hsabEnrollmentStore = useHsabEnrollmentStore();
  bankAccountStore = useBankAccountStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  featureFlagStore = useFeatureFlagStore();
  hsabExpenseReimbursementMethodMap = hsabExpenseReimbursementMethodMap;
  RouteNames = RouteNames;

  mounted () {
    this.contactInformationStore.getContactInformation();
    this.bankAccountStore.loadLinkedBankAccounts();
  }

  get hasDirectDepositAccount () {
    return this.bankAccountStore.hasDirectDeposit;
  }

  get directDepositAccountNumberLast4 () {
    if (this.bankAccountStore.activeDirectDepositAccount) {
      return this.bankAccountStore.activeDirectDepositAccount.bankAccountNumber;
    }
    return "";
  }

  get userHasPlanNotSetToDirectDeposit () {
    return this.hsabEnrollmentStore.isPlanYearEnrollmentDataLoaded
        && this.hasDirectDepositAccount
        && this.hsabEnrollmentStore.userHasNonDirectDepositReimbursementMethod;
  }
  get expenseReimbursementMethod (): string {
    return this.hsabExpenseReimbursementMethodMap[this.hsabEnrollmentStore.reimbursementMethod];
  }

  onLinkAccountSettingsClicked () {
    this.hsabExpenseFormStore.closeModal();
    this.$router.push({ name: RouteNames.LinkedAccountsSettings });
  }
}
